import {blue, grey} from "@mui/material/colors";
import {Button, ButtonProps, Typography} from "@mui/material";
import {useAppContext} from "@/contexts/AppContext.tsx";

interface PrimaryButtonProps extends ButtonProps {
    light?: boolean
    to?: string
    isLoading?: boolean
    sx?: any
    props?: any
}

export default function PrimaryButton({children, light = false, sx, ...props}: PrimaryButtonProps) {
    const {uiVisual} = useAppContext();

    const bgcolor = {
        classic: light ? 'white' : blue[900],
        modern: light ? '#ECF4FF' : blue[900]
    }

    // const color = {
    //     classic: light ? 'black' : 'white',
    //     modern: light ? 'transparent' : blue[900]
    // }

    const button = {
        classic: {
            height: 35.69,
            px: 1.5,
            bgcolor: bgcolor[uiVisual],
            color: bgcolor[uiVisual],
            borderRadius: 0,
            border: light ? '1px solid #bdbdbd' : '1px solid transparent',
            textTransform: 'unset',
            svg: {
                fill: light ? grey[900] : 'white'
            },
            "&:hover": {
                bgcolor: light ? 'white' : blue[800],
            },
            "&:disabled": {
                bgcolor: bgcolor[uiVisual],
                opacity: 0.5
            },
            opacity: props.disabled ? 0.5 : 1
        },
        modern: {
            height: 35.69,
            px: 1.5,
            bgcolor: bgcolor[uiVisual],
            color: bgcolor[uiVisual],
            svg: {
                fill: light ? blue[900] : 'white'
            },
            "&:hover": {
                bgcolor: light ? 'white' : blue[800],
                border: '1px solid transparent',
                outline: 'none'
            },
            "&:disabled": {
                bgcolor: bgcolor[uiVisual],
                opacity: 0.5
            },
            border: light ? '1px solid transparent' : '1px solid transparent',
            textTransform: 'unset',
            opacity: props.disabled ? 0.5 : 1
        }
    }

    const text = {
        classic: {
            color: light ? grey[900] : 'white',
        },
        modern: {
            color: light ? blue[900] : 'white'
        }
    }

    return (
        <Button sx={{...button[uiVisual], ...sx}} {...props}>
            <Typography component="span" fontSize={14} fontWeight={500} sx={text[uiVisual]} textTransform="unset">
                {children}
            </Typography>
        </Button>
    )
}